var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app-bar',{attrs:{"app":"","color":"transparent","flat":""}},[_c('v-spacer'),_c('img',{staticClass:"mt-4",attrs:{"align-with-title":"","height":"80","src":require("../../assets/images/aace-logo.jpg")},on:{"click":_vm.goHome}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }